import styles from "./styles.module.css";

export default function Triggers({ open }) {

  if (!open) return null;
  return (
    <div className={styles.section}>
      <div className={styles.triggers}>
        <div className={styles.text}>Coming Soon!</div>
      </div>
    </div>
  )
}